import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { Button, type Column, Heading, Paragraph, Table } from "@fronterahealth/frontera-ui-components";

import { type GetOrganizationsOutput, useBasecampOrganizationsRetrieve } from "@api/rest/types-and-hooks";

const COLUMNS: Column<GetOrganizationsOutput>[] = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (value) => (
      <Paragraph displayType="loud" size="small" colorType="primary">
        {value}
      </Paragraph>
    ),
  },
  {
    title: "Staff Count",
    dataIndex: "staff_count",
    key: "staff_count",
    render: (value) => <Paragraph size="small">{value}</Paragraph>,
  },
  {
    title: "Active Clients",
    dataIndex: "active_clients",
    key: "active_clients",
    render: (value) => <Paragraph size="small">{value}</Paragraph>,
  },
  {
    title: "Created",
    dataIndex: "created_date",
    key: "created_date",
    render: (value) => <Paragraph size="small">{format(new Date(value as string), "MM/dd/yyyy")}</Paragraph>,
  },
];

export const Organizations: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useBasecampOrganizationsRetrieve();

  const organizations: GetOrganizationsOutput[] =
    data?.status === 200 ? (Array.isArray(data.data) ? data.data : [data.data]) : [];

  return (
    <div className="flex flex-col min-h-full">
      <div className="flex items-end justify-between px-16 pb-4 pt-8 shrink-0">
        <Heading size="medium">Organizations</Heading>
        <Button
          variant="primary"
          buttonStyle="filled"
          size="sm"
          text="+ Add Organization"
          onClick={() => navigate("/organizations/new")}
        />
      </div>
      <div className="px-16 pb-8">
        <Table
          data={organizations}
          columns={COLUMNS}
          loading={isLoading}
          showSearch
          showPagination
          defaultItemsPerPage={25}
          itemsPerPageOptions={[10, 25, 50]}
          onRowClick={(row) => navigate(`/organizations/${row.id}`)}
        />
      </div>
    </div>
  );
};
